import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { KeywordsService } from './keywords.service';

@Pipe({
  name: 'highlight'
})
export class HighlightKeywordsPipe implements PipeTransform {

  constructor(private keywordsService: KeywordsService, private sanitizer: DomSanitizer) {
    
  }

  transform(text: string, ...args: unknown[]): unknown {
    // if there is no text or if there are no keywords, just return whatever 
    // text value was originally supplied.
    if (!text || !this.keywordsService.keywords) return text;

    // pre-sanities the user's input strig because we never trust user imput
    text = this.sanitizer.sanitize(SecurityContext.HTML, text);

    // Highlight each keyword and set it up as trusted text because it has
    // html embedded in it.    
    text = text.replace(this.keywordsService.regex, this.keywordsService.replacer);
    let safeText: SafeHtml = this.sanitizer.bypassSecurityTrustHtml(text);

    return safeText;
  }

  // transform(value: any, args: string): any {
  //   if (!args) {
  //     return value;
  //   }
  //   const specials = [
  //     // order matters for these
  //     "-"
  //     , "["
  //     , "]"
  //     // order doesn't matter for any of these
  //     , "/"
  //     , "{"
  //     , "}"
  //     , "("
  //     , ")"
  //     , "*"
  //     , "+"
  //     , "?"
  //     , "."
  //     , "\\"
  //     , "^"
  //     , "$"
  //     , "|"
  //   ];

  //   const text = this.keywordsService.tokenize(value);

  //   const result= text.replace(this.keywordsService.regex, this.keywordsService.replacer);

  //   const rgxEscaper = RegExp('[' + specials.join('\\') + ']', 'g');

  //   args = args.replace(rgxEscaper, "\\$&");

  //   // Match in a case insensitive maneer
  //   const re = new RegExp(`\\\\?${args}` + `(?!([^<]+)?>)`, 'g');
  //   const match = value.match(re);

  //   // If there's no match, just return the original value.
  //   if (!match) {
  //     return value;
  //   }

  //   const replacedValue = value.replace(re, "<span style='background-color:gold'>" + match[0] + "</span>")
  //   return this.sanitizer.bypassSecurityTrustHtml(result);  //replacedValue)
  // }
  
}
